import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';

/**
 * @subcomponent SellingPoints
 *
 * @deprecated use a pattern of other SWAN components instead; please see the documentation site.
 */ const SellingPointsFeatureDescription = deprecatedComponent({
    displayName: 'SellingPointsFeatureDescription',
    description: 'Use a pattern of other SWAN components instead; please see the documentation site.',
    root: createComponent({
        displayName: 'SellingPointsFeatureDescription',
        root: 'p',
        propConfig: {
            classNames: [
                'swan-selling-points-feature-description'
            ]
        }
    })
});

export { SellingPointsFeatureDescription };
